export default "__VITE_ASSET__D8K2iZEg__"